import React from 'react'
import { Text } from '@usap/uicomponents'
import HoverBox from './style/BoxWithBorder.css'

const BoxWithBorder = ({
  selected,
  pointer,
  padH,
  round = true,
  corner,
  height = '40px',
  width = '40px',
  disabled = false,
  count,
  ...props
}) => (
  <HoverBox
    height={height}
    width={width}
    background={selected ? 'dark-2' : 'white'}
    align="center"
    justify="center"
    border={{
      side: 'all', color: 'light-3', style: 'solid', size: 'xsmall',
    }}
    round={round ? { size: 'xsmall', corner } : false}
    disabled={disabled}
    style={
      pointer && !disabled
        ? { cursor: 'pointer', userSelect: 'none' }
        : { userSelect: 'none' }
    }
    {...props}
  >
    <Text size="small" weight="normal" color={selected ? 'white' : 'dark-2'}>
      {count}
    </Text>
  </HoverBox>
)
export default BoxWithBorder
